export default __webpack_public_path__ + "static/media/logo.2de5f09b.png";